import {
  FiCalendar,
  FiGrid,
  FiHelpCircle,
  FiMessageCircle,
  FiPhone,
  FiTarget,
  FiFileText,
  FiSettings,
  FiMapPin,
  FiList,
  FiSmartphone,
  FiZap,
  FiMessageSquare,
  FiLink,
  FiGift,
  FiSlash,
  FiSend,
  FiFilter,
  FiTag,
  FiRadio,
} from 'react-icons/fi';
import { FaInstagram } from 'react-icons/fa';

/** Sidebar / subnav structure (page elements wired in EngagementApp routes). */
export const ENGAGEMENT_SECTIONS = [
  {
    section: 'Overview',
    sectionId: 'overview',
    items: [{ segment: '', label: 'Dashboard', IconComponent: FiGrid, end: true }],
  },
  {
    section: 'Operations',
    sectionId: 'operations',
    items: [
      { segment: 'leads', label: 'Leads', IconComponent: FiTarget },
      { segment: 'appointments', label: 'Appointments', IconComponent: FiCalendar, badge: 'appointments_attention' },
      { segment: 'services', label: 'Services', IconComponent: FiList },
      { segment: 'my-number', label: 'Your number', IconComponent: FiSmartphone },
    ],
  },
  {
    section: 'AI training',
    sectionId: 'engagement-ai',
    items: [{ segment: 'ai-docs', label: 'General knowledge', IconComponent: FiFileText }],
  },
  {
    section: 'Campaigns',
    sectionId: 'engagement-campaigns',
    items: [
      { segment: 'automations', label: 'Automations', IconComponent: FiZap },
      { segment: 'offers', label: 'Offers', IconComponent: FiGift },
      { segment: 'campaigns', label: 'Campaigns', IconComponent: FiSend },
      { segment: 'segments', label: 'Segments', IconComponent: FiFilter },
      { segment: 'coupon-offers', label: 'Coupon offers', IconComponent: FiTag },
      { segment: 'ad-campaigns', label: 'Ad campaigns', IconComponent: FiRadio },
      { segment: 'conversations', label: 'Conversations', IconComponent: FiMessageCircle },
      { segment: 'opted-out', label: 'Opted out', IconComponent: FiSlash },
      { segment: 'human-intervention', label: 'Human intervention', IconComponent: FiHelpCircle, badge: 'open_handoffs' },
      { segment: 'call-records', label: 'Call records', IconComponent: FiPhone },
    ],
  },
  {
    section: 'HQ settings',
    sectionId: 'engagement-hq',
    items: [
      { segment: 'agent-settings', label: 'Agent settings', IconComponent: FiSettings },
      { segment: 'instagram', label: 'Instagram', IconComponent: FaInstagram },
      { segment: 'branches', label: 'Branches & numbers', IconComponent: FiMapPin },
      { segment: 'wa-accounts', label: 'WhatsApp accounts', IconComponent: FiLink },
      { segment: 'templates', label: 'Message templates', IconComponent: FiMessageSquare },
    ],
  },
];

/** HQ-only screens (hidden on the franchise partner desk; the server refuses changes from it too). */
export const HQ_SEGMENTS = new Set([
  'ai-docs',
  'agent-settings',
  'instagram',
  'branches',
  'wa-accounts',
  'templates',
  'campaigns',
  'segments',
  'coupon-offers',
  'ad-campaigns',
]);

/** Account and branch-number setup lives in the WhatsApp module when HQ is in the workspace. */
const MOVED_TO_WHATSAPP = new Set(['wa-accounts', 'branches']);

/** Franchise desk only: a read-only view of this branch's WhatsApp number. */
const PARTNER_SEGMENTS = new Set(['my-number']);

export const ENGAGEMENT_NAV_ROUTES = ENGAGEMENT_SECTIONS.flatMap((s) => s.items);

/** Partner franchise desk: operations + conversations; HQ controls agent settings, numbers, knowledge and reminders. */
export function getEngagementSections(portal) {
  const hq = portal !== 'partner';
  return ENGAGEMENT_SECTIONS
    .map((section) => {
      const items = section.items.filter((item) => {
        if (MOVED_TO_WHATSAPP.has(item.segment)) return portal === 'standalone';
        if (HQ_SEGMENTS.has(item.segment)) return hq;
        if (PARTNER_SEGMENTS.has(item.segment)) return !hq;
        return true;
      });
      if (!items.length) return null;
      return { ...section, items };
    })
    .filter(Boolean);
}

export function getEngagementNavRoutes(portal) {
  return getEngagementSections(portal).flatMap((s) => s.items);
}

export const ENGAGEMENT_REDIRECTS = {
  'rag-upload': 'ai-docs',
  automation: 'automations',
  reminders: 'automations', // the built-in reminders are Automations → Reminders
  calls: 'call-records',
};
